import React from "react";
import "./video.scss";

const Video = ({ videoId }) => {
  return (
    <section id="offert">
      <div id="main_video">
        <div id="video">
          <iframe
            width="648"
            height="365"
            src={`https://www.youtube.com/embed/${videoId}?modestbranding=1&rel=0&vq=hd1080`}
            title="YouTube video player"
            frameBorder="0"
            allowFullScreen
          ></iframe>
        </div>
        <div id="description">
          <h5>Obejrzyj video, z którego dowiesz się więcej o kursie...</h5>
          <b>Zajmie Ci to 3,5 minuty!</b>
          <br />W każdej chwili możesz przejść niżej.
        </div>
      </div>
    </section>
  );
};

export default Video;
